<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <div class="row">
            <div class="col-xl-12">
              <!--Begin::Portlet-->

              <div
                class="m-portlet m-portlet--rounded m-portlet--bordered m-portlet--head-sm m-portlet--unair"
                :m-portlet="'true'"
              >
                <form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                  <div class="m-portlet__body">
                    <div class="m-pricing-table-2">
                      <div class="m-pricing-table-2__head">
                        <div class="m-pricing-table-2__title">
                          <h3>{{ $t('advertise.ContractDirectoryServicesv2') }}</h3>
                          <div class="container mt-4">
                            <div v-html="$t('advertise.DirectoryServiceDescv3')" />
                            <p>
                              <a
                                :href="`${websiteURL}/advertise/business#premium-info`"
                                target="_blank"
                                class="btn m-btn--pill btn-primary d-inline-block\"
                              >{{ $t('common.MoreInfo') }}</a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="m-pricing-table-2__content">
                        <div class="m-pricing-table-2__container">
                          <div class="container">
                            <div class="m-pricing-table-2__items">
                              <div class="row">
                                <div class="col-xl-4">
                                  <div class="m-pricing-table-2__item py-4 px-1">
                                    <h2 class="m-pricing-table-2__subtitle mt-0 mb-4">
                                      {{ $t('advertise.BusinessBasic') }}
                                    </h2>
                                    <ul class="list-unstyled price-features">
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.profile' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.positionStandard' ) }}
                                      </li>
                                      <li class="text-crossed mb-2">
                                        {{ $t( 'advertise.directoryFeatures.highlighted' ) }}
                                      </li>
                                      <li class="text-crossed mb-2">
                                        {{ $t( 'advertise.directoryFeatures.websiteLink' ) }}
                                      </li>
                                      <li class="text-crossed mb-2">
                                        {{ $t( 'advertise.directoryFeatures.banner' ) }}
                                      </li>
                                      <li>
                                        <a
                                          :href="`${websiteURL}/advertise/business#standard-info`"
                                          target="_blank"
                                        >{{ $t( 'common.MoreInfo') }}</a>
                                      </li>
                                    </ul>
                                    <div
                                      id="Basic"
                                      :class="{ price_container: true }"
                                    >
                                      <span class="m-pricing-table-2__price">0</span>
                                      <span class="m-pricing-table-2__label">€</span>
                                      <div class="m-pricing-table-2__btn my-0">
                                        <router-link
                                          :to="{ name: 'Directories' }"
                                          class="btn m-btn--pill  btn-primary m-btn--wide m-btn--uppercase m-btn--bolder m-btn--lg"
                                        >
                                          {{ $t('advertise.getNow') }}
                                        </router-link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xl-4">
                                  <div class="m-pricing-table-2__item py-4 px-1">
                                    <h2 class="m-pricing-table-2__subtitle mt-0 mb-4">
                                      {{ $t('advertise.BusinessBasicPlus') }}
                                    </h2>
                                    <ul class="list-unstyled price-features">
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.profile' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.positionPriority' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.highlighted' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.websiteLink' ) }}
                                      </li>
                                      <li class="text-crossed mb-2">
                                        {{ $t( 'advertise.directoryFeatures.banner' ) }}
                                      </li>
                                      <li>
                                        <a
                                          :href="`${websiteURL}/advertise/business#featured-info`"
                                          target="_blank"
                                        >{{ $t( 'common.MoreInfo') }}</a>
                                      </li>
                                    </ul>
                                    <div
                                      id="Pro"
                                      :class="{ price_container: true, 'active': isProductSelected( 'pro' ) }"
                                    >
                                      <span class="m-pricing-table-2__price">{{ pkgs[ 'pro' ].price }}</span>
                                      <span class="m-pricing-table-2__label">€</span>
                                      <div class="m-pricing-table-2__btn my-0">
                                        <button
                                          type="button"
                                          class="btn m-btn--pill  btn-primary m-btn--wide m-btn--uppercase m-btn--bolder m-btn--lg"
                                          data-toggle="button"
                                          aria-pressed="false"
                                          @click.stop.prevent="selectProduct( 'pro' )"
                                        >
                                          {{ $t('advertise.Contract') }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xl-4">
                                  <div class="m-pricing-table-2__item py-4 px-1">
                                    <h2 class="m-pricing-table-2__subtitle mt-0 mb-4">
                                      {{ $t('advertise.BusinessPro') }}
                                    </h2>
                                    <ul class="list-unstyled price-features">
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.profile' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.positionTopPriority' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.highlighted' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.websiteLink' ) }}
                                      </li>
                                      <li class="mb-2">
                                        {{ $t( 'advertise.directoryFeatures.banner' ) }}
                                      </li>
                                      <li>
                                        <a
                                          :href="`${websiteURL}/advertise/business#premium-info`"
                                          target="_blank"
                                        >{{ $t( 'common.MoreInfo') }}</a>
                                      </li>
                                    </ul>
                                    <div
                                      id="Pro+Banner"
                                      :class="{ price_container: true, 'active': isProductSelected( 'pro+banner') }"
                                    >
                                      <span class="m-pricing-table-2__price">{{ pkgs[ 'pro+banner' ].price }}</span>
                                      <span class="m-pricing-table-2__label">€</span>
                                      <div class="m-pricing-table-2__btn my-0">
                                        <button
                                          type="button"
                                          class="btn m-btn--pill  btn-primary m-btn--wide m-btn--uppercase m-btn--bolder m-btn--lg"
                                          data-toggle="button"
                                          aria-pressed="false"
                                          data-ts-price="95"
                                          data-ts-num-prop="1"
                                          data-ts-service="premium"
                                          @click.stop.prevent="selectProduct( 'pro+banner' )"
                                        >
                                          {{ $t('advertise.Contract') }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  v-if="service.Price"
                                  class="col-lg-12 text-center pt-5"
                                >
                                  <span class="pb-5">
                                    <h4>{{ totalText }}</h4>
                                  </span>
                                  <button
                                    class="btn m-btn--pill mt-5 btn-success m-btn--wide btn-block"
                                    @click.stop.prevent="sendForm"
                                  >
                                    {{ $t('advertise.SendContract') }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 text-center pb-4">
                      <span
                        v-if="service.Price"
                        class="d-block d-md-block d-lg-inline ml-lg-4"
                      >
                        <i class="la la-asterisk m--icon-font-size-sm5" /> {{ $t('advertise.PricesWithoutVAT') }}
                      </span>
                      <span class="d-block m--icon-font-size-sm4">
                        {{ $t('advertise.ToContractPropertyServicesPleaseGoTo') }}
                        <router-link
                          :to="{ name: 'Advertise'}"
                          class="m-menu__link"
                        >
                          {{ $t('advertise.ContractPropertyServices') }}
                        </router-link>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '../common/Header.vue';
import AppFooter from '../common/Footer.vue';
import LeftMenu from '../common/menus/LeftMenu.vue';
import { getUser, onBeforeOpenSwal } from '../../../functions.ts';
import { clientapi }  from '../../../api-clients/client-api.js';
import { businessBrandPackages } from './directory-prices.js';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
    },
    data() {
        return {
            service: {},
        };
    },
    computed: {
        pkgs() {
            return businessBrandPackages;
        },
        totalText() {
            return this.$t( 'advertise.TOTAL' ) + ': ' + this.service.Price + '€*/' + this.$t( 'common.month' );
        },
        websiteURL() {
            if ( this.$i18n.locale === 'en' ) {
                return import.meta.env.TWC_TS_URL;
            } else {
                return import.meta.env.TWC_TS_URL + '/es';
            }
        },
    },
    mounted() {
        if ( this.$route.query.selected && decodeURIComponent( this.$route.query.selected ) === 'pro' ) {
            this.selectProduct( 'pro' );
        } else if ( this.$route.query.selected && decodeURIComponent( this.$route.query.selected === 'pro+banner' ) ) {
            this.selectProduct( 'pro+banner' );
        }
    },
    methods: {
        async sendForm() {
            const user = getUser();

            const params = {
                subject: 'New Directory Services Request',
                body: `Directory Services to contract: ${this.service.Type}${this.service.Properties}<br>User: ${user.Login}<br>${this.totalText}`,
                language: this.$i18n.locale,
            };

            const response = await clientapi.post( '/contact-advertise', params );

            if ( response.status === 200 ) {
                swal( {
                    title: this.$t( 'advertise.FormSubmitedTitle' ),
                    text: this.$t( 'advertise.FormSubmitedText' ),
                    type: 'success',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
            } else {
                let errorCode = response.data.code;

                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.server.' + errorCode ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
            }
        },
        selectProduct( productID ) {
            if ( this.service && this.service.Type && this.service.Type === businessBrandPackages[ productID ].name ) {
                this.service = {};
                this.$router.push( { query: {} } );
            } else {
                this.service = {
                    Properties: 1,
                    Type: businessBrandPackages[ productID ].name,
                    Price: businessBrandPackages[ productID ].price,
                };

                this.$router.push( {
                    query: {
                        selected: encodeURIComponent( productID ),
                    },
                } );
            }
        },
        isProductSelected( productID ) {
            return this.service && this.service.Type && this.service.Type === businessBrandPackages[ productID ].name;
        },
    },
};

</script>
<style scoped lang="scss">
  .m-pricing-table-2__container {
    max-width: 100% !important;
  }

  .m-pricing-table-2__items {
    box-shadow: none !important;
  }

  .m-pricing-table-2__item {
    background-color: #f8f6f5;
  }

  .text-crossed {
    text-decoration: line-through;
    color: #d8d8d8;
  }
</style>
